import React from 'react';
import { withAppContext } from '../../../contexts/AppContext';
import BrowserHistory from '../../utils/BrowserHistory';
import WorkflowControls from './WorkflowControls';
import { Button } from '@amzn/awsui-components-core';
import constants from '../../../common/constants';

class BarRaiserContentViewerControls extends WorkflowControls {
  protected renderActionControls(disabled: boolean) {
    return (
      <Button variant="primary" onClick={this.navigateToQuestionnaire} disabled={disabled}>
        {constants.EVALUATE_PUBLICATION_QUALITY}
      </Button>
    );
  }

  private navigateToQuestionnaire = async () => {
    const { contentId } = this.props;
    window.open(`/bar-raiser/questionnaire/${contentId}`, '_blank');
  };
}

export default withAppContext(BarRaiserContentViewerControls);
